import { useEffect } from 'react';
import { useCanvasSession } from '../contexts/CanvasSessionContext';

export const CANVAS_EDIT_INTENT_EVENT = 'landi-canvas-edit-intent';

export interface CanvasEditIntentDetail {
  instruction: string;
  page?: string;
}

export function dispatchCanvasEditIntent(detail: CanvasEditIntentDetail): void {
  window.dispatchEvent(new CustomEvent(CANVAS_EDIT_INTENT_EVENT, { detail }));
}

/** Listens for edit intents (chat panel or external UI) and runs virtual FS edit loop. */
export function useEditIntentListener(): void {
  const { requestSiteEdit } = useCanvasSession();

  useEffect(() => {
    const handler = (event: Event): void => {
      const detail = (event as CustomEvent<CanvasEditIntentDetail>).detail;
      if (!detail?.instruction?.trim()) {
        return;
      }
      void requestSiteEdit({
        instruction: detail.instruction,
        page: detail.page,
      });
    };
    window.addEventListener(CANVAS_EDIT_INTENT_EVENT, handler);
    return () => window.removeEventListener(CANVAS_EDIT_INTENT_EVENT, handler);
  }, [requestSiteEdit]);
}
